import { useState } from "react";
import { useIntl } from "react-intl";
import { useAuth } from "src/app/utils/useAuth";
import { PageTitle } from "src/_metronic/layout/core";
import { SimpleEntityGrid } from "src/app/components/grid/SimpleEntityGrid";
import {
    UpsertOrderFormContainer,
    ReviewTextOrderFormContainer,
    AddProofreaderToOrderContainer,
    UpsertOrderFormBodyModalContainer,
} from "src/app/containers";
import { OrderTransport } from "src/app/transports/order";
import { Order, UpsertOrderDTOSchema } from "src/app/types/orders/order";
import useProofreadGridActions from "./useProofreadGridActions";
import useProofreadGridColumns from "./useProofreadGridColumns";
import useProofreaderGridToolbarButtons from "./useProofreaderGridToolbarButtons";

const ProofreadGrid = () => {
    const { formatMessage } = useIntl();
    const { currentUser } = useAuth();
    const [selectedRows, setSelectedRows] = useState<Array<Order>>([]);
    const [showModal, setShowModal] = useState(false);
    const gridColumns = useProofreadGridColumns();
    const [orderToUpdateGrid, setValueToUpdateGrid] = useState(false);
    const actions = useProofreadGridActions(currentUser);

    const handleAddProofreaderAction = (obj: any) => {
        setSelectedRows(obj.selectedRows);
        setShowModal(true);
    };
    const toolActionsButton = useProofreaderGridToolbarButtons(
        currentUser.role,
        handleAddProofreaderAction
    );

    const handlerValueToUpdateGrid = (update: boolean) => {
        setValueToUpdateGrid(update);
    };
    const handleClose = () => {
        setShowModal(false);
    };
    const orderAsSendToUpdateGrid = () => {
        setValueToUpdateGrid(false);
    };

    return (
        <>
            <PageTitle>{formatMessage({ id: "proofread.title" })}</PageTitle>
            <SimpleEntityGrid
                //GRID
                columns={gridColumns}
                orderAsSendToUpdateGrid={orderAsSendToUpdateGrid}
                orderToUpdateGrid={orderToUpdateGrid}
                listHandler={OrderTransport.listToProofreader}
                //ACTIONS
                actions={actions}
                viewTextFormBodyContainer={ReviewTextOrderFormContainer}
                toggleActiveHandler={OrderTransport.toggleActive}
                UpsertFormBodyContainer={UpsertOrderFormBodyModalContainer}
                //TOOLBAR
                toolbarButtonAction={toolActionsButton}
                //EDIT
                modalProps={{ size: "xl" }}
                saveHandler={OrderTransport.save}
                entityName={formatMessage({ id: "common.entity.proofread" })}
                validationSchema={UpsertOrderDTOSchema}
                formTransformer={OrderTransport.formTransformer}
                formBody={UpsertOrderFormContainer}
            />
            <AddProofreaderToOrderContainer
                selectedRows={selectedRows}
                handlerValueToUpdateGrid={handlerValueToUpdateGrid}
                handleClose={handleClose}
                showModal={showModal}
            />
        </>
    );
};

export default ProofreadGrid;
